import React, { useEffect, useState } from 'react';
import { Route, Switch, useParams } from 'react-router-dom';
import MatchGameStore from '../../match/store';
import SoccerMatchGame from './game';
import clsx from 'clsx';
import { useMemo } from 'react';
import MatchTab from '../../match/tab';
import MatchOdds from '../../match/odds';
import SoccerMatchBroadcast from './broadcast/SoccerMatchBroadcast';
import GoBack from '../../../../components/goBack';
import MatchCheer from '../../match/cheer';
import SoccerStat from './record';
import Analysis from '../../match/analysis';
import BannerSportCheer from '../../../../components/banner-sport-cheer';

const SoccerMatch = () => {
  let { id, type } = useParams();
  const { getScoreDetail, data, closeSocket } = MatchGameStore();
  const [isSmallView, toggleSmallView] = useState(false);
  const [viewAd, setViewAd] = useState(true);

  useEffect(() => {
    getScoreDetail('soccer', id);
    return () => {
      closeSocket();
    };
  }, []);

  useEffect(() => {
    if (viewAd) {
      setViewAd(false);
    }
    setTimeout(() => {
      setViewAd(true);
    }, 500);
  }, [type]);

  const trackerClass = useMemo(() => {
    if (!!data.detail.getTracker) {
      if (data.detail.getTracker.class === 'wait') {
        return 'ready';
      } else {
        return data.detail.getTracker.class;
      }
    } else {
      return 'ready';
    }
  }, [data.detail]);

  return (
    <div className={clsx('score_detail_wrap', isSmallView && 'small_view', trackerClass)}>
      <div className='summary'>
        <GoBack isRecord />
        <h2 className='tit'>
          {data.init && data.detail.league.hasOwnProperty('shortName') && data.detail.league.shortName}
        </h2>
        <button className='btn_oc' onClick={() => toggleSmallView(!isSmallView)}>
          크게보기/작게보기
        </button>
      </div>

      {/* 상단 경기 정보 */}
      {data.init && <SoccerMatchGame item={data.detail} />}
      {/* 상단 경기 정보 끝 */}

      <BannerSportCheer />

      {/* 탭 */}
      <MatchTab id={id} sportsType={'soccer'} />
      {/* 탭 끝 */}

      <Switch>
        <Route
          exact
          path='/match/soccer/:id/cheer'
          render={() => (
            <MatchCheer
              sportsType='soccer'
              sportsId={1}
              detail={data.detail}
              toggleSmallView={toggleSmallView}
              isSmallView={isSmallView}
              isInit={data.init}
            />
          )}
        />
        <Route
          exact
          path='/match/soccer/:id/analysis'
          render={() => <Analysis sportsType={'soccer'} sportsId={1} gameId={id} />}
        />
        <Route
          exact
          path='/match/soccer/:id/record'
          render={() => <SoccerStat sportsType={'soccer'} gameData={data} />}
        />
        <Route exact path='/match/soccer/:id/odds' render={() => <MatchOdds sportsType={'soccer'} gameData={data} />} />
        <Route exact path='/match/soccer/:id/broadcast' component={SoccerMatchBroadcast} />
      </Switch>
    </div>
  );
};

export default SoccerMatch;
